import {
  ItemToSplitSchema,
  attributesForNewFulfillmentGroupsSchema,
} from "@redotech/redo-fulfillment-operations-common/split-fulfillment-group";
import * as z from "zod";

export const splitFulfillmentGroup = {
  name: "splitFulfillmentGroup" as const,
  input: z.object({
    originalGroupId: z.string(),
    itemsToSplit: z.array(ItemToSplitSchema),
    attributesForNewFulfillmentGroups:
      attributesForNewFulfillmentGroupsSchema.nullish(),
    scanVerifyOriginalGroup: z.boolean().nullish(),
    keepAutoMerge: z.boolean().nullish(),
  }),
  output: z.object({
    success: z.boolean(),
    warningMessage: z.string().nullish(),
    newGroupIds: z.array(z.string()).nullish(),
    newGroupsByRedoOrderId: z.record(z.string(), z.array(z.string())).nullish(),
    pickSessionDisposition: z
      .enum(["not-linked", "not-printed", "reconciled", "cancelled"])
      .optional(),
  }),
};
